(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    (()=>{if(!document.querySelectorAll("form.newsletter-form .form-message").length)return;const o=decodeURIComponent(location.hash.slice(1)),s=o?document.getElementById(o):null,t=s&&s.matches("form.newsletter-form")&&s.querySelector(".form-message")?s:null;if(t){const a=(t.querySelector("[data-newsletter-tags]")?.value||"").split(",").map(e=>e.trim());if(a.includes("camo-waitlist")&&!a.includes("newsletter")&&t.querySelector("[data-newsletter-success]"))try{sessionStorage.setItem("oro-camo-waitlist","1")}catch{}document.querySelectorAll("form.newsletter-form").forEach(e=>{if(e===t)return;e.querySelectorAll(".form-message").forEach(r=>r.remove()),e.querySelectorAll("[aria-invalid]").forEach(r=>r.removeAttribute("aria-invalid")),e.querySelectorAll('[aria-describedby$="-error"]').forEach(r=>r.removeAttribute("aria-describedby"));const n=e.querySelector("[data-newsletter-fields]");n&&(n.hidden=!1)})}const l=(t||document).querySelector("[data-newsletter-success]");if(!l)return;const c=()=>setTimeout(()=>l.focus({preventScroll:!!t}),0);document.readyState==="complete"?c():window.addEventListener("load",c,{once:!0})})();
  } catch(e) { console.error(e); }
})();

})();
